import { NAME } from './constants';
export const SEARCH_MATERIALS = 'SEARCH_MATERIALS';
export const SEARCH_PRESSROOMS = 'SEARCH_PRESSROOMS';
export const LOAD_MORE_MATERIALS = 'LOAD_MORE_MATERIALS';
export const LOAD_MORE_PRESSROOMS = 'LOAD_MORE_PRESSROOMS';
export const CLEAR_SEARCH_RESULTS_MATERIALS = 'CLEAR_SEARCH_RESULTS_MATERIALS';
export const CLEAR_SEARCH_RESULTS_PRESSROOMS =
  'CLEAR_SEARCH_RESULTS_PRESSROOMS';
export const CHANGE_ALERT_DATA = `${NAME}/CHANGE_ALERT_DATA`;
export const CREATE_ALERT = `${NAME}/CREATE_ALERT`;
export const CREATE_ALERT_SUCCESS = `${NAME}/CREATE_ALERT_SUCCESS`;
export const CREATE_ALERT_FAILURE = `${NAME}/CREATE_ALERT_FAILURE`;
export const SHOW_CREATE_ALERT_OVERLAY = `${NAME}/SHOW_CREATE_ALERT_OVERLAY`;
export const HIDE_CREATE_ALERT_OVERLAY = `${NAME}/HIDE_CREATE_ALERT_OVERLAY`;

export const changeAlertData = (name, value) => ({
  type: CHANGE_ALERT_DATA,
  payload: {
    name,
    value,
  },
});

export const createAlert = payload => ({
  type: CREATE_ALERT,
  payload,
});

export const showCreateAlert = () => ({
  type: SHOW_CREATE_ALERT_OVERLAY,
});

export const closeCreateAlertOverlay = () => ({
  type: HIDE_CREATE_ALERT_OVERLAY,
});

export const searchMaterials = (query, topics, regions, site) => ({
  type: SEARCH_MATERIALS,
  payload: {
    query,
    topics,
    regions,
    site,
  },
});

export const searchPressrooms = (query, topics, regions, site) => ({
  type: SEARCH_PRESSROOMS,
  payload: {
    query,
    topics,
    regions,
    site,
  },
});

export const loadMoreMaterials = link => ({
  type: LOAD_MORE_MATERIALS,
  payload: {
    link,
  },
});

export const loadMorePressrooms = link => ({
  type: LOAD_MORE_PRESSROOMS,
  payload: {
    link,
  },
});

export const clearMaterialsSearchResults = () => ({
  type: CLEAR_SEARCH_RESULTS_MATERIALS,
});

export const clearPressroomsSearchResults = () => ({
  type: CLEAR_SEARCH_RESULTS_PRESSROOMS,
});
